module.exports = __webpack_public_path__ + "img/wechat.b644eca3.svg";